export default __webpack_public_path__ + "acb8393f3fb9c59b15c90d965440ee57.svg";